class Apps {
    constructor(_request) {
        this.request = _request;
    }

    list() {
        return this.request.fetch({ method: "GET", endpoint: "apps" });
    }

    create(_data) {
        return this.request.fetch({
            method: "POST",
            endpoint: "apps/create",
            params: _data
        });
    }
    
}

export default Apps;
